import GotraMasterContainer from "../../container/admin/gotra-master";

const GotraMaster = () => {
    return <GotraMasterContainer />;
};

export default GotraMaster;